import { dateToStr } from '@ps-smart-cp/ppfw-client';
import type { CarryOverViewMode } from '../templates/carry-over/types/CarryOverViewMode';

function createProcessingMonth(
  viewMode: CarryOverViewMode,
  processingMonth: Date | null,
  dateFormat: string,
) {
  if (processingMonth === null) {
    return '';
  }

  const date =
    viewMode === 'current'
      ? processingMonth
      : new Date(processingMonth.getFullYear(), processingMonth.getMonth() + 1);
  return dateToStr(date, dateFormat);
}

export { createProcessingMonth };
